import React, { useState } from "react";

import {
  Button,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

import InformationModal from "../../components/InformationModal";
import Loader from "../../components/Loader";
import { usersApi } from "../../services/userServices";
import brand from "../../assets/img/brand.png";
import { useNavigate, useParams } from "react-router-dom";

const RecoverPassword = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [password, setPassword] = useState("");
  const [repassword, setRePassword] = useState("");

  const [informationModal, setInformationModal] = useState({
    isOpen: false,
    title: "",
    body: "",
  });

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    usersApi
      .recoverPassword({ passwordToken: params.code, password })
      .then(() => {
        setLoading(false);
        setInformationModal({
          isOpen: true,
          title: "Alright!",
          body: "Password reset successfully.",
        });
      })
      .catch(() => {
        setLoading(false);
        setInformationModal({
          isOpen: true,
          title: "Oops!",
          body: "There was a problem resetting your password, please retry.",
        });
      });
  };

  return (
    <React.Fragment>
      <div className="text-center mt-4">
        <h1 className="h2">Reset password</h1>
        <p className="lead">Enter your new password</p>
      </div>
      <Card>
        <CardBody>
          <div className="m-sm-4">
            <div className="text-center">
              <img
                src={brand}
                className="rounded p-0 col-10"
                alt={"Vulcan Fund"}
              />
            </div>
            <Form onSubmit={onSubmit}>
              <FormGroup>
                <Label>New Password</Label>
                <Input
                  onChange={(event) => setPassword(event.currentTarget.value)}
                  required={true}
                  maxLength="50"
                  bsSize="lg"
                  type={"password"}
                  name="password"
                  placeholder="Enter your new password"
                  defaultValue={password}
                />
              </FormGroup>
              <FormGroup>
                <Label>Confirm New Password</Label>
                <Input
                  onChange={(event) => setRePassword(event.currentTarget.value)}
                  required={true}
                  maxLength="50"
                  bsSize="lg"
                  type={"password"}
                  name="repassword"
                  className={
                    repassword.length && password.length
                      ? repassword !== password
                        ? "border-danger"
                        : "border-success"
                      : ""
                  }
                  placeholder="Re enter your new password"
                  defaultValue={repassword}
                />
              </FormGroup>
              <div className="text-center mt-3">
                {loading ? (
                  <Loader size="sm" />
                ) : (
                  <Button
                    color="primary"
                    size="lg"
                    type="submit"
                    disabled={
                      repassword.length > 0 &&
                      password.length > 0 &&
                      repassword !== password
                    }
                  >
                    Confirm
                  </Button>
                )}
              </div>
            </Form>
          </div>
        </CardBody>
      </Card>
      {informationModal?.isOpen ? (
        <InformationModal
          title={informationModal.title}
          body={informationModal.body}
          onClose={() => navigate("/auth/sign-in")}
        />
      ) : null}
    </React.Fragment>
  );
};

export default RecoverPassword;
